import React, { useEffect, useState } from "react";
import axios from "axios";
import "./rolling.css";

const API_BASE =
  "https://peralassery.cubixsystems.com/myapp/api/uploads";

const SITE_BASE =
  "https://peralassery.cubixsystems.com/myapp";

function Rolling() {
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${API_BASE}/get_notice.php`);

      const data = Array.isArray(res.data) ? res.data : [];

      setUploads(data);
    } catch (error) {
      console.error("Error loading notices:", error);
      setUploads([]);
    } finally {
      setLoading(false);
    }
  };

  const openNotice = (row) => {
    if (!row?.file_path) return;

    let fileUrl = row.file_path;

    // If API already returns a full URL
    if (!/^https?:\/\//i.test(fileUrl)) {
      fileUrl = `${SITE_BASE}/${fileUrl.replace(/^\/+/, "")}`;
    }

    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  if (loading) {
    return (
      <div className="news-ticker">
        <div className="ticker-label">
          <span className="ticker-label-icon">📢</span>
          <span>Latest Updates</span>
        </div>

        <div className="ticker-window">
          <div className="ticker-loading">Loading latest updates...</div>
        </div>
      </div>
    );
  }

  if (uploads.length === 0) {
    return null;
  }

  return (
    <div className="news-ticker">
      {/* LEFT SIDE LABEL */}
      <div className="ticker-label">
        <span className="ticker-label-icon">📢</span>
        <span className="ticker-label-text">Latest Updates</span>
      </div>

      {/* SCROLLING AREA */}
      <div className="ticker-window">
        <div className="ticker-track">
          {/* FIRST COPY */}
          <div className="ticker-group">
            {uploads.map((row, index) => (
              <TickerItem
                key={`first-${row.id || index}`}
                row={row}
                onClick={() => openNotice(row)}
              />
            ))}
          </div>

          {/* SECOND COPY FOR SEAMLESS LOOP */}
          <div className="ticker-group" aria-hidden="true">
            {uploads.map((row, index) => (
              <TickerItem
                key={`second-${row.id || index}`}
                row={row}
                onClick={() => openNotice(row)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function TickerItem({ row, onClick }) {
  const clickable = Boolean(row?.file_path);

  return (
    <div
      className={`ticker-item ${
        clickable ? "ticker-clickable" : "ticker-disabled"
      }`}
      onClick={clickable ? onClick : undefined}
      role={clickable ? "button" : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={(e) => {
        if (!clickable) return;

        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <span className="ticker-arrow">➤</span>

      <span className="ticker-text">
        {row?.name || "Latest Update"}
      </span>

      {clickable && (
        <span className="ticker-open-icon" aria-hidden="true">
          ↗
        </span>
      )}

      <span className="ticker-separator">•</span>
    </div>
  );
}

export default Rolling;